/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, OnInit, inject } from '@angular/core';
import { PayzService } from '@src/app/modules/txn/payzService';
import { first } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { combineLatest } from 'rxjs';
import { MatCardModule } from '@angular/material/card';
@Component({
    selector: 'app-confirm-page',
    templateUrl: './confirm-page.component.html',
    styleUrls: ['./confirm-page.component.scss'],
    imports: [MatCardModule]
})
export class ConfirmPageComponent implements OnInit {
    private payzSvc = inject(PayzService);
    protected activeRoute = inject(ActivatedRoute);


    instructionReceived = false;
    payz = null;
    payzMandate = null;
    sessionId: string = null;
    isMandate = false;
    payzChecked = false;

    ngOnInit(): void {
        combineLatest([this.activeRoute.params, this.activeRoute.queryParamMap]).subscribe(
            ([params, queryParams]) => {
                this.sessionId = params.sessionId;
                this.instructionReceived = true;
                if (queryParams.has('isMandate')) {
                    console.log('Is a mandate', queryParams, params);
                    this.isMandate = true;
                    this.payzSvc.getMandate(params.sessionId).pipe(first()).subscribe(payzMandate => {
                        this.payzMandate = payzMandate;
                        this.payzChecked = true;
                    });
                } else {
                    console.log('Not a mandate', queryParams, params);
                    this.isMandate = false;
                    this.payzSvc.getSession(params.sessionId).pipe(first()).subscribe(payz => {
                        this.payz = payz;
                        this.payzChecked = true;
                    });
                }
            }
        );
    }
}
